import styled from 'styled-components';
import { Grid } from '@mui/material';
import Card from '../../../atoms/Card'

// export const Container = styled(Grid)`
//   justify-content: center;
// `;

export const Container = styled(Grid)`
  display: flex;
  justify-content: center;
`;

export const FormContent = styled.div`
  display: flex;
  /* justify-content: center; */
  flex-direction: column;
  max-width: 46.875rem;
`;

export const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: cepadding;
  text-align: center;
  padding: 50px;
  margin-bottom: 50px;
`;
export const TermsContainer = styled.div`
  text-align: left;
  padding: 30px 0;
`;
